const currencyDetails = {
    aed : 'د.إ',
    afn : '؋',
    all : 'L',
    amd : '֏',
    ang : 'ƒ',
    aoa : 'Kz',
    ars : '$',
    aud : '$',
    awg : 'ƒ',
    azn : '₼',
    bam : 'KM',
    bbd : '$',
    bdt : '৳',
    bgn : 'лв',
    bhd : '.د.ب',
    bif : 'FBu',
    bmd : '$',
    bnd : '$',
    bob : '$b',
    bov : 'BOV',
    brl : 'R$',
    bsd : '$',
    btc : '₿',
    btn : 'Nu.',
    bwp : 'P',
    byn : 'Br',
    byr : 'Br',
    bzd : 'BZ$',
    cad : '$',
    cdf : 'FC',
    che : 'CHE',
    chf : 'CHF',
    chw : 'CHW',
    clf : 'CLF',
    clp : '$',
    cny : '¥',
    cop : '$',
    cou : 'COU',
    crc : '₡',
    cuc : '$', 
    cup : '₱',
    cve : '$', 
    czk : 'Kč', 
    djf : 'Fdj', 
    dkk : 'kr',
    dop : 'RD$',
    dzd : 'دج', 
    eek : 'kr', 
    egp : '£', 
    ern : 'Nfk',
    etb : 'Br', 
    eth : 'Ξ',
    eur : '€', 
    fjd : '$', 
    fkp : '£', 
    gbp : '£', 
    gel : '₾', 
    ggp : '£', 
    ghc : '₵',
    ghs : 'GH₵',
    gip : '£',
    gmd : 'D',
    gnf : 'FG', 
    gtq : 'Q',
    gyd : '$',
    hkd : '$',
    hnl : 'L',
    hrk : 'kn',
    htg : 'G',
    huf : 'Ft',
    idr : 'Rp',
    ils : '₪',
    imp : '£', 
    inr : '₹',
    iqd : 'ع.د',
    irr : '﷼', 
    isk : 'kr',
    jep : '£',
    jmd : 'J$', 
    jod : 'JD', 
    jpy : '¥',
    kes : 'KSh',
    kgs : 'лв',
    khr : '៛', 
    kmf : 'CF',
    kpw : '₩',
    krw : '₩',
    kwd : 'KD', 
    kyd : '$', 
    kzt : '₸',
    lak : '₭',
    lbp : '£', 
    lkr : '₨',
    lrd : '$',
    lsl : 'M',
    ltc : 'Ł', 
    ltl : 'Lt',
    lvl : 'Ls',
    lyd : 'LD',
    mad : 'MAD', 
    mdl : 'lei',
    mga : 'Ar', 
    mkd : 'ден',
    mmk : 'K',
    mnt : '₮',
    mop : 'MOP$', 
    mro : 'UM',
    mru : 'UM', 
    mur : '₨', 
    mvr : 'Rf',
    mwk : 'MK',
    mxn : '$',
    mxv : 'MXV',
    myr : 'RM',
    mzn : 'MT',
    nad : '$',
    ngn : '₦',
    nio : 'C$',
    nok : 'kr',
    npr : '₨',
    nzd : '$',
    omr : '﷼',
    pab : 'B/.',
    pen : 'S/.',
    pgk : 'K',
    php : '₱',
    pkr : '₨',
    pln : 'zł',
    pyg : 'Gs',
    qar : '﷼',
    rmb : '￥',
    ron : 'lei',
    rsd : 'Дин.',
    rub : '₽',
    rwf : 'R₣',
    sar : '﷼',
    sbd : '$',
    scr : '₨',
    sdg : 'ج.س.',
    sek : 'kr',
    sgd : 'S$',
    shp : '£',
    sll : 'Le',
    sos : 'S',
    srd : '$',
    ssp : '£',
    std : 'Db',
    stn : 'Db', 
    svc : '$',
    syp : '£',
    szl : 'E',
    thb : '฿',
    tjs : 'SM', 
    tmt : 'T',
    tnd : 'د.ت',
    top : 'T$',
    trl : '₤',
    'try' : '₺',
    ttd : 'TT$',
    tvd : '$',
    twd : 'NT$',
    tzs : 'TSh',
    uah : '₴',
    ugx : 'USh',
    usd : '$',
    uyi : 'UYI',
    uyu : '$U',
    uyw : 'UYW',
    uzs : 'лв',
    vef : 'Bs',
    ves : 'Bs.S',
    vnd : '₫',
    vuv : 'VT',
    wst : 'WS$',
    xaf : 'FCFA',
    xbt : 'Ƀ',
    xcd : '$',
    xof : 'CFA', 
    xpf : '₣',
    xsu : 'Sucre',
    xua : 'XUA',
    yer : '﷼',
    zar : 'R',
    zmw : 'ZK',
    zwd : 'Z$',
    zwl : '$'
};

export const userCurrency = {
    currencyDetails
}